import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { RouteConstants } from 'src/assets/constants/route';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { PermissionsDialog } from 'src/app/services/model';

import { CleverTapConstents, ConstantData } from 'src/app/services/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  routers = RouteConstants.routes;

  userName = 'Welcome';

  isShowLogin: boolean = true;
  loading:boolean = false;
  lat: any;
  lng: any;
  pincode:any;
  mobMenutab: string = 'home';
  searchVisible: boolean = false;
  searchData:any;
  searchValue:string = ''
  timeOutSearch:any;
  noDataFound:boolean = false;
  get eLProducts() {
    const products = this.util.getCache('products');
    if (!products)
      return [];
    const product = products.find((item: any) => item.id === '1');
    if (!this.util.getCache('product'))
      this.util.setCache('product', product);
    return product;
  }

  permissionDialog: boolean = false;

  constructor(public util: UtilService, private route: ActivatedRoute, private router: Router) {

    this.router.events.subscribe((val) => {
      if (this.router.url == RouteConstants.routes.login) {
        this.isShowLogin = false
      }
      else {
        this.isShowLogin = true;
      }
    });

  }
  dialogpermission:PermissionsDialog = {
    show:false, 
    title:'',
    contentText:'',
  };

  ngOnInit(): void {
    this.util.permissionsService.permissionsDialogObs.subscribe((data:PermissionsDialog)=>{
      this.dialogpermission = data;
    })
    this.requestLocation();
    this.util.userLoggedInEventCalled.subscribe(() => {
      this.requestLocation(true);
    });
    if (this.util.isMobile) {
      $(window).click(() => {
        $('#mob_menu_sec').removeClass('show');
      });
    }
    


  }

  mouseEnter(){
    this.util.cleverTapEventCall(CleverTapConstents.view_the_product);
  }
  loadProduct(product: any, cat: any) {
    this.util.cleverTapEventCall('Viewing the sub product', {'subProductName': product.name || 'NA'})
    this.hideMenu({stopPropagation:()=>{}});
    if (this.lat) {
      localStorage.setItem('product', JSON.stringify(product));
      localStorage.setItem('cat', JSON.stringify(cat));
      localStorage.setItem('lat',this.lat);
      localStorage.setItem('lng',this.lng);

      if (!this.util.isUserLoggedIn) {
      this.util.route('login');
    }
    else{
      // this.util.loadProduct(product, cat, this.lat, this.lng);
      this.util.route('institutes')

    }
      
        // this.util.route('institutes;')
    }else{
      this.requestLocation();
    }
    
  }

  login() {
    this.util.route('login');
  }


  logout() {
    this.util.logout();
    this.util.popupVisible = false;
  }

  showFooter() {
    this.util.route('footer');
  }

  showUserDropdown() {
    $('.user-dropdown').slideToggle(300);
  }

  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  showMenu(evt: any) {
    evt.stopPropagation();
    $('#mob_menu_sec').addClass('show');
  }
  hideMenu(evt: any) {
    evt.stopPropagation();
    this.mobMenutab = 'home' 
    $('#mob_menu_sec').removeClass('show');
  }

  iconRefresh(): void {
    this.util.route('home');
    setTimeout(() => {
      this.util.clearInstitudeData();
      location.reload();
    }, 1000);
  }
  

  stopProp(evt: any) {
    evt.stopPropagation();
  }
  requestLocation(isFirst: boolean = false) {
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          this.util.setCache('lat', this.lat);
          this.util.setCache('lng', this.lng);
          
          if (this.permissionDialog || isFirst) {
            this.util.getPincode(this.lat,this.lng).then((res:any)=>{
              this.pincode = res.pincode;
              this.util.setCache('pincode',this.pincode);
              const _deviceData: any = {};
              _deviceData['deviceType'] = 'WEB';
              _deviceData['lat'] = this.lat + '';
              _deviceData['lng'] = this.lng + '';
              _deviceData['zipCode'] = this.pincode + '';
              this.util.isUserLoggedIn && this.util.handleRequests('put', this.util.getUrl('user_onLogin'), _deviceData).then(() => { 
                this.util.askForCameraPermission();
              }).catch(()=>{
                this.util.logout();
              });
             });
          
          }
          this.permissionDialog = false;
          
        }

      },
        (error: any) => {
          if(!this.util.isUserLoggedIn){
            setTimeout(() => {
              this.requestLocation();
            }, ConstantData.permissionTimer);
          }
          this.permissionDialog = true;
        });


    }
    if( this.util.isUserLoggedIn){
      setTimeout(() => {
        this.requestLocation();
      }, ConstantData.permissionTimer);
    }
 
  }

  searchCourse(ev: any) {
    const query = ev.target.value || '';
   
    if (this.timeOutSearch)
      clearTimeout(this.timeOutSearch);
    if (!query) {
      this.searchData = null;
      return;
    }
    

    this.timeOutSearch = setTimeout(() => {
      this.loading = true;
      this.searchData = null;
      this.noDataFound = false;
      this.util.searchAllCoursesInstitudes(query, 0, 10, false).then((res: any) => {
        this.searchData = res;
        if(!this.searchData?.content || !this.searchData.content.length ){
          this.noDataFound = true;
        }
        this.loading = false;
      }).catch(()=>{
        this.noDataFound = true;
      });
    }, 500);

  }

  selectCourse(course: any) {
    
    this.searchData = null;
    this.searchValue = '';
    this.searchVisible = false;
    this.util.selectCourse(course);
  }
}
